module.exports = __webpack_public_path__ + "static/media/3. LKC museum pic.fccc263f.png";